// TransformerCapacityCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Menghitung Kapasitas Transformator";
const DESCRIPTION =
  "Gunakan kalkulator kapasitas transformator untuk menghitung kapasitas transformator listrik untuk fasilitas apa pun dengan mudah dan akurat. Masukkan tegangan dan kuat arus untuk mendapatkan kapasitas yang diperlukan menggunakan rumus yang sesuai.";
const KEYWORDS =
  "kalkulator kapasitas transformator, menghitung kapasitas transformator, listrik, studi beban, kuat arus, tegangan listrik, energi listrik";
const OG_URL =
  "https://do-calculate.com/calculator/id/transformer-capacity-calculator/";
function TransformerCapacityCalculator() {
  const [voltage, setVoltage] = useState("");
  const [current, setCurrent] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [steps, setSteps] = useState([]);
  const handleCalculate = () => {
    try {
      if (!voltage || !current) {
        setError("Harap masukkan tegangan dan kuat arus.");
        return;
      }
      const sqrt3 = Math.sqrt(3);
      const capacity = sqrt3 * parseFloat(voltage) * parseFloat(current);
      const calculationSteps = [
        `Akar kuadrat dari angka 3 = ${sqrt3.toFixed(2)}`,
        `Tegangan listrik = ${voltage} Volt`,
        `Kuat arus = ${current} Ampere`,
        `Kapasitas transformator = ${sqrt3.toFixed(
          2
        )} × ${voltage} × ${current} = ${capacity.toFixed(2)} Watt`,
      ];
      setResult(capacity.toFixed(2));
      setSteps(calculationSteps);
      setError("");
    } catch (err) {
      setError("Terjadi kesalahan saat menghitung. Silakan coba lagi.");
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menghitung kapasitas transformator listrik untuk fasilitas apa pun
                  menggunakan persamaan berikut:
                </p>
                <p>
                  <strong>
                    Kapasitas Transformator = Akar Kuadrat dari 3 × Tegangan × Kuat Arus
                  </strong>
                </p>
                <ul>
                  <li>
                    Masukkan tegangan listrik dan kuat arus yang diperlukan untuk menghitung kapasitas transformator.
                  </li>
                  <li>
                    Pastikan untuk mempelajari semua beban dan arus start sebelum
                    perhitungan.
                  </li>
                </ul>
                <p>
                  Kalkulator ini dikembangkan untuk memudahkan proses menghitung kapasitas transformator listrik
                  dan memastikan kebutuhan fasilitas terpenuhi secara efisien.
                </p>
                <hr />
              </div>
              <br />
            </div>
               <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="voltage">
                      <label className="form-label ms-2">
                        Masukkan Tegangan Listrik (Volt)
                      </label>
                      <input
                        id="voltage"
                        type="number"
                        value={voltage}
                        onChange={(e) => setVoltage(e.target.value)}
                        placeholder="Masukkan tegangan listrik"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="current">
                      <label className="form-label ms-2">
                        Masukkan Kuat Arus (Ampere)
                      </label>
                      <input
                        id="current"
                        type="number"
                        value={current}
                        onChange={(e) => setCurrent(e.target.value)}
                        placeholder="Masukkan kuat arus"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Kesalahan: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">Hasil:</h4>
                      <p className="text-white">{result} Watt</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4>Langkah-langkah:</h4>
                        <ul>
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Apa itu Kapasitas Transformator Listrik?</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Konsep Kapasitas Transformator Listrik
                    </h2>
                  </u>
                  <p>
                    Kapasitas transformator listrik adalah jumlah energi yang dapat ditransfer transformator
                    dari satu rangkaian ke rangkaian lain tanpa kehilangan energi yang signifikan. Kapasitas diukur
                    biasanya dalam Watt (W) atau kilowatt (kW).
                  </p>
                  <ul>
                    <li>
                      <strong>
                        Kapasitas Transformator = Akar Kuadrat dari 3 × Tegangan × Kuat Arus
                      </strong>
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: Jika tegangan 400 Volt dan kuat arus 10 Ampere, maka kapasitas
                    transformator sama dengan: √3 × 400 × 10 ≈ 6928 Watt
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Cara Menghitung Kapasitas Transformator Listrik
                    </h2>
                  </u>
                  <p>Untuk menghitung kapasitas transformator listrik, ikuti langkah-langkah berikut:</p>
                  <ul>
                    <li>
                      Pelajari semua beban yang akan ada di fasilitas dan tentukan
                      tegangan dan kuat arus untuk setiap beban.
                    </li>
                    <li>Hitung kuat arus start untuk semua beban dan motor.</li>
                    <li>Hitung rata-rata kuat arus total.</li>
                    <li>
                      Gunakan rumus untuk menghitung kapasitas transformator:
                      <br />
                      <strong>Kapasitas Transformator = √3 × Tegangan × Kuat Arus</strong>
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: Jika fasilitas membutuhkan daya 6928 Watt, Anda dapat memilih
                    transformator dengan kapasitas yang sesuai seperti 7.5 kW.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>
                  </u>
                  <p>
                    Jawaban untuk beberapa pertanyaan umum tentang kapasitas transformator listrik
                    dan perhitungannya.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Pertanyaan: Mengapa kita menggunakan akar kuadrat dari 3 dalam menghitung kapasitas
                    transformator?
                    <br />
                    Jawaban: Kita menggunakan akar kuadrat dari 3 untuk menghitung kapasitas transformator dalam
                    sistem tiga fase, yang mencerminkan hubungan antara tegangan dan arus dalam sistem ini.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default TransformerCapacityCalculator;